export const socialsData = {
    github: 'https://github.com/dev-deveshverma',
    linkedIn: 'https://www.linkedin.com/in/dev-deveshverma',
    instagram: 'https://www.instagram.com/dev_deveshverma',
    codepen: 'https://codepen.io/dev-deveshverma',
    medium: 'https://medium.com/@dev-deveshverma',
}
